import { useCallback, useState } from "react";

const useToggle = (initialState = false) => {
	const [isOpen, setIsOpen] = useState(initialState);
	const toggle = useCallback((state) => setIsOpen((prev) => {
		if (typeof state === "boolean") {
			return state;
		}
		return !prev;
	}), []);

	return [isOpen, toggle];
};

export default useToggle;
